module.exports = __webpack_public_path__ + "img/1F1EB-1F1EE.357fdbe2.svg";